import { useEffect, useState } from 'react';
import { companiesService } from '../../services/companies';
import Modal from '../../components/Modal';
import StatusMessage from '../../components/StatusMessage';
import TrialFields, { defaultTrialForm, parseTrialForm, type TrialFormState } from './TrialFields';
import { firstErrorMessage } from './CreateCompanyModal';
import type { AdminCompanySubscription } from '../../types';

const TrialQuotaModal = ({
  open,
  onClose,
  companyId,
  subscription,
  onSaved,
}: {
  open: boolean;
  onClose: () => void;
  companyId: string;
  subscription: AdminCompanySubscription;
  onSaved: () => void;
}) => {
  const [form, setForm] = useState<TrialFormState>(defaultTrialForm());
  const [msg, setMsg] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  // Re-prefill from the current subscription each time the dialog opens, so a reload
  // after a previous save is reflected rather than the stale first-open values.
  useEffect(() => {
    if (!open) return;
    setForm(defaultTrialForm({
      stationQuota: String(subscription.station_quota),
      addonUserQuota: String(subscription.addon_user_quota),
    }));
    setMsg(null);
  }, [open, subscription]);

  const save = async () => {
    setMsg(null);
    const parsed = parseTrialForm(form);
    if ('error' in parsed) {
      setMsg(parsed.error);
      return;
    }
    setSaving(true);
    try {
      await companiesService.updateTrial(companyId, parsed.value);
      onSaved();
    } catch (e) {
      setMsg(firstErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} title="Ubah kuota trial" onClose={() => !saving && onClose()}>
      <div className="space-y-1 text-sm">
        <TrialFields form={form} onChange={setForm} />
        <StatusMessage error={msg} />
        <button onClick={save} disabled={saving} className="bg-primary-600 text-white rounded px-4 py-2 w-full mt-3 disabled:opacity-50">
          {saving ? 'Menyimpan…' : 'Simpan'}
        </button>
      </div>
    </Modal>
  );
};
export default TrialQuotaModal;
